import React from 'react'
import { Tooltip } from 'react-tooltip'

interface Props {
    errno: number | string
}
export class CurlErrno extends React.PureComponent<Props> {
    public render = () => {
        const { errno } = this.props

        let details = knownErrors[+errno]
        if (!details) {
            details = { name: 'UNKNOWN' }
        }

        return (
            <div
                className="text-ellipsis"
                data-tooltip-id="curlTooltip"
                data-tooltip-content={details.description ? `${details.name}: ${details.description}` : details.name}
            >
                [{errno}] {details.name}
                <Tooltip id="curlTooltip" place="right-start" className="tw-react-tooltip" />
            </div>
        )
    }
}
// Extracted from: https://github.com/curl/curl/blob/681df5ec517e1477b07b5df2df42bc0617f33c18/include/curl/curl.h#L519-L662
const knownErrors: { [code: number]: { name: string; description?: string } } = {
    0: { name: 'CURLE_OK' },
    1: { name: 'CURLE_UNSUPPORTED_PROTOCOL' },
    2: { name: 'CURLE_FAILED_INIT' },
    3: { name: 'CURLE_URL_MALFORMAT' },
    4: {
        name: 'CURLE_NOT_BUILT_IN',
        description: '[was obsoleted in August 2007 for 7.17.0, reused in April 2011 for 7.21.5]',
    },
    5: { name: 'CURLE_COULDNT_RESOLVE_PROXY' },
    6: { name: 'CURLE_COULDNT_RESOLVE_HOST' },
    7: { name: 'CURLE_COULDNT_CONNECT' },
    8: { name: 'CURLE_WEIRD_SERVER_REPLY' },
    9: {
        name: 'CURLE_REMOTE_ACCESS_DENIED',
        description: 'a service was denied by the server due to lack of access - when login fails this is not returned',
    },
    10: {
        name: 'CURLE_FTP_ACCEPT_FAILED',
        description: '[was obsoleted in April 2006 for 7.15.4, reused in Dec 2011 for 7.24.0]',
    },
    11: { name: 'CURLE_FTP_WEIRD_PASS_REPLY' },
    12: {
        name: 'CURLE_FTP_ACCEPT_TIMEOUT',
        description: 'timeout occurred accepting server [was obsoleted in August 2007 for 7.17.0, reused in Dec 2011 for 7.24.0]',
    },
    13: { name: 'CURLE_FTP_WEIRD_PASV_REPLY' },
    14: { name: 'CURLE_FTP_WEIRD_227_FORMAT' },
    15: { name: 'CURLE_FTP_CANT_GET_HOST' },
    16: {
        name: 'CURLE_HTTP2',
        description: 'A problem in the http2 framing layer. [was obsoleted in August 2007 for 7.17.0, reused in July 2014 for 7.38.0]',
    },
    17: { name: 'CURLE_FTP_COULDNT_SET_TYPE' },
    18: { name: 'CURLE_PARTIAL_FILE' },
    19: { name: 'CURLE_FTP_COULDNT_RETR_FILE' },
    20: { name: 'CURLE_OBSOLETE20', description: 'NOT USED' },
    21: { name: 'CURLE_QUOTE_ERROR', description: 'quote command failure' },
    22: { name: 'CURLE_HTTP_RETURNED_ERROR' },
    23: { name: 'CURLE_WRITE_ERROR' },
    24: { name: 'CURLE_OBSOLETE24', description: 'NOT USED' },
    25: { name: 'CURLE_UPLOAD_FAILED', description: 'failed upload "command"' },
    26: { name: 'CURLE_READ_ERROR', description: 'could not open/read from file' },
    27: { name: 'CURLE_OUT_OF_MEMORY' },
    28: { name: 'CURLE_OPERATION_TIMEDOUT', description: 'the timeout time was reached' },
    29: { name: 'CURLE_OBSOLETE29', description: 'NOT USED' },
    30: { name: 'CURLE_FTP_PORT_FAILED', description: 'FTP PORT operation failed' },
    31: { name: 'CURLE_FTP_COULDNT_USE_REST', description: 'the REST command failed' },
    32: { name: 'CURLE_OBSOLETE32', description: 'NOT USED' },
    33: { name: 'CURLE_RANGE_ERROR', description: 'RANGE "command" did not work' },
    34: { name: 'CURLE_OBSOLETE34' },
    35: { name: 'CURLE_SSL_CONNECT_ERROR', description: 'wrong when connecting with SSL' },
    36: { name: 'CURLE_BAD_DOWNLOAD_RESUME', description: 'could not resume download' },
    37: { name: 'CURLE_FILE_COULDNT_READ_FILE' },
    38: { name: 'CURLE_LDAP_CANNOT_BIND' },
    39: { name: 'CURLE_LDAP_SEARCH_FAILED' },
    40: { name: 'CURLE_OBSOLETE40', description: 'NOT USED' },
    41: { name: 'CURLE_OBSOLETE41', description: 'NOT USED starting with 7.53.0' },
    42: { name: 'CURLE_ABORTED_BY_CALLBACK' },
    43: { name: 'CURLE_BAD_FUNCTION_ARGUMENT' },
    44: { name: 'CURLE_OBSOLETE44', description: 'NOT USED' },
    45: { name: 'CURLE_INTERFACE_FAILED', description: 'CURLOPT_INTERFACE failed' },
    46: { name: 'CURLE_OBSOLETE46', description: 'NOT USED' },
    47: { name: 'CURLE_TOO_MANY_REDIRECTS', description: 'catch endless re-direct loops' },
    48: { name: 'CURLE_UNKNOWN_OPTION', description: 'User specified an unknown option' },
    49: { name: 'CURLE_SETOPT_OPTION_SYNTAX', description: 'Malformed setopt option' },
    50: { name: 'CURLE_OBSOLETE50', description: 'NOT USED' },
    51: { name: 'CURLE_OBSOLETE51', description: 'NOT USED' },
    52: { name: 'CURLE_GOT_NOTHING', description: 'when this is a specific error' },
    53: { name: 'CURLE_SSL_ENGINE_NOTFOUND', description: 'SSL crypto engine not found' },
    54: { name: 'CURLE_SSL_ENGINE_SETFAILED', description: 'can not set SSL crypto engine as default' },
    55: { name: 'CURLE_SEND_ERROR', description: 'failed sending network data' },
    56: { name: 'CURLE_RECV_ERROR', description: 'failure in receiving network data' },
    57: { name: 'CURLE_OBSOLETE57', description: 'NOT IN USE' },
    58: { name: 'CURLE_SSL_CERTPROBLEM', description: 'problem with the local certificate' },
    59: { name: 'CURLE_SSL_CIPHER', description: 'could not use specified cipher' },
    60: {
        name: 'CURLE_PEER_FAILED_VERIFICATION',
        description: "peer's certificate or fingerprint was not verified fine",
    },
    61: { name: 'CURLE_BAD_CONTENT_ENCODING', description: 'Unrecognized/bad encoding' },
    62: { name: 'CURLE_OBSOLETE62', description: 'NOT IN USE since 7.82.0' },
    63: { name: 'CURLE_FILESIZE_EXCEEDED', description: 'Maximum file size exceeded' },
    64: { name: 'CURLE_USE_SSL_FAILED', description: 'Requested FTP SSL level failed' },
    65: { name: 'CURLE_SEND_FAIL_REWIND', description: 'Sending the data requires a rewind that failed' },
    66: { name: 'CURLE_SSL_ENGINE_INITFAILED', description: 'failed to initialise ENGINE' },
    67: { name: 'CURLE_LOGIN_DENIED', description: 'user, password or similar was not accepted and we failed to login' },
    68: { name: 'CURLE_TFTP_NOTFOUND', description: 'file not found on server' },
    69: { name: 'CURLE_TFTP_PERM', description: 'permission problem on server' },
    70: { name: 'CURLE_REMOTE_DISK_FULL', description: 'out of disk space on server' },
    71: { name: 'CURLE_TFTP_ILLEGAL', description: 'Illegal TFTP operation' },
    72: { name: 'CURLE_TFTP_UNKNOWNID', description: 'Unknown transfer ID' },
    73: { name: 'CURLE_REMOTE_FILE_EXISTS', description: 'File already exists' },
    74: { name: 'CURLE_TFTP_NOSUCHUSER', description: 'No such user' },
    75: { name: 'CURLE_OBSOLETE75', description: 'NOT IN USE since 7.82.0' },
    76: { name: 'CURLE_OBSOLETE76', description: 'NOT IN USE since 7.82.0' },
    77: { name: 'CURLE_SSL_CACERT_BADFILE', description: 'could not load CACERT file, missing or wrong format' },
    78: { name: 'CURLE_REMOTE_FILE_NOT_FOUND', description: 'remote file not found' },
    79: {
        name: 'CURLE_SSH',
        description: 'error from the SSH layer, somewhat generic so the error message will be of interest when this has happened',
    },
    80: { name: 'CURLE_SSL_SHUTDOWN_FAILED', description: 'Failed to shut down the SSL connection' },
    81: {
        name: 'CURLE_AGAIN',
        description: 'socket is not ready for send/recv, wait till it is ready and try again (Added in 7.18.2)',
    },
    82: {
        name: 'CURLE_SSL_CRL_BADFILE',
        description: 'could not load CRL file, missing or wrong format (Added in 7.19.0)',
    },
    83: { name: 'CURLE_SSL_ISSUER_ERROR', description: 'Issuer check failed.  (Added in 7.19.0)' },
    84: { name: 'CURLE_FTP_PRET_FAILED', description: 'a PRET command failed' },
    85: { name: 'CURLE_RTSP_CSEQ_ERROR', description: 'mismatch of RTSP CSeq numbers' },
    86: { name: 'CURLE_RTSP_SESSION_ERROR', description: 'mismatch of RTSP Session Ids' },
    87: { name: 'CURLE_FTP_BAD_FILE_LIST', description: 'unable to parse FTP file list' },
    88: { name: 'CURLE_CHUNK_FAILED', description: 'chunk callback reported error' },
    89: { name: 'CURLE_NO_CONNECTION_AVAILABLE', description: 'No connection available, the session will be queued' },
    90: { name: 'CURLE_SSL_PINNEDPUBKEYNOTMATCH', description: 'specified pinned public key did not match' },
    91: { name: 'CURLE_SSL_INVALIDCERTSTATUS', description: 'invalid certificate status' },
    92: { name: 'CURLE_HTTP2_STREAM', description: 'stream error in HTTP/2 framing layer' },
    93: { name: 'CURLE_RECURSIVE_API_CALL', description: 'an api function was called from inside a callback' },
    94: { name: 'CURLE_AUTH_ERROR', description: 'an authentication function returned an error' },
    95: { name: 'CURLE_HTTP3', description: 'An HTTP/3 layer problem' },
    96: { name: 'CURLE_QUIC_CONNECT_ERROR', description: 'QUIC connection error' },
    97: { name: 'CURLE_PROXY', description: 'proxy handshake error' },
    98: { name: 'CURLE_SSL_CLIENTCERT', description: 'client-side certificate required' },
    99: { name: 'CURLE_UNRECOVERABLE_POLL', description: 'poll/select returned fatal error' },
    100: { name: 'CURLE_TOO_LARGE', description: 'a value/data met its maximum' },
    101: { name: 'CURLE_ECH_REQUIRED', description: 'ECH tried but failed' },
}
